module.exports = __webpack_public_path__ + "img/SeafarersHeroes_home.97b94e0d.jpg";